import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/concreteclasses';

export const getConcreteClassesStatistical = async (projectId) => {
  return axios.get(`${endPoint}/statistical/${projectId}`);
};

export const getConcreteClasses100 = async (projectId) => {
  return axios.get(`${endPoint}/100/${projectId}`);
};

export const getLG14Report = async (type, projectId) => {
  return axios.get(`${endPoint}/${type}/${projectId}/lg14`);
};

export const exportConcreteClassReport = async (concreteClass, project) => {
  return axios.post(`${endPoint}/export`, {
    certified_dis: false,
    concrete_quality: false,
    ...concreteClass,
    project,
  });
};
